const translations = {
  fr: {
    sales: {
      accept: 'Accepter',
      actions: 'Actions',
      addOpportunities: 'Ajouter des occasions',
      averageFrequency: 'Fréquence moyenne',
      calcul: 'Estimation',
      cancel: 'Annuler',
      chooseDateForTheCampaign: 'Choisissez les semaines de la campagne',
      client: 'Client',
      cost: 'Coût',
      createProposition: 'Créer une proposition',
      campaignDates: 'Dates de la campagne',
      decline: 'Refuser',
      diffusion: 'Diffusion',
      estimationDate: 'Date de l\'estimation',
      estimationError: 'Une erreur est survenue pendant le calcul de l\'estimation',
      flyerInformationMessage: 'Performances hebdomadaires du {{from, LL}} au {{to, LL}}',
      flyerPageTitle: 'Flyer',
      flyerCalculationText: '* Veuillez noter que les données pour la dernière semaine complète sont calculées dans la nuit de lundi à mardi',
      history: 'Historique',
      averageWeeklyHoursOfListening: 'Écoute hebdomadaire moyenne',
      averageWeeklyReach: 'Portée hebdomadaire moyenne',
      averageWeeklyHoursOfListeningPerPerson: 'Écoute hebdomadaire moyenne par personne',
      impressions: 'Impressions',
      modify: 'Modifier',
      modifyProposition: 'Modifier une proposition',
      nbOfOccasions: 'Nombre d\'occasions',
      noEstimation: 'Pas d\'estimation récente',
      noProposition: 'Aucune proposition',
      notCalculated: 'L\'estimation n\'a pas été calculée',
      noTitle: 'Pas de titre',
      propose: 'Proposer',
      proposedOn: 'Proposée le',
      propositions: 'Propositions',
      estimationsPageTitle: 'Estimations',
      saveProposition: 'Enregistrer',
      saveAndSend: 'Enregistrer et envoyer',
      send: 'Envoyer',
      title: 'Titre',
      requiredTitle: 'Titre requis',
      requiredCustomer: 'Client requis',
      totalReach: 'Portée totale',
      bestWeeklyReach: 'Meilleure portée hebdomadaire',
      bestWeeklyTotalListening: 'Meilleure écoute hebdomadaire',
      bestWeeklyTotalListeningPerPerson: 'Meilleure écoute par personne',
      cumulativeReach: 'Portée cumulative',
      estimation: 'Estimation',
      description: 'Description',
      comments: 'Notes',
      sendProposition: 'Envoyer une proposition',
      fetchCustomersError: 'Une erreur est survenue lors du chargenent des clients',
      selectCustomer: 'Choisir un client',
      from: 'Du',
      to: 'Au',
      sendPropositionError: 'Une erreur est survenue lors de l\'envoi de la proposition',
      propositionSent: 'La proposition a été envoyée',
      acceptForCustomer: 'Accepter pour le client',
      declineForCustomer: 'Refuser pour le client',
      propositionCancelled: 'La proposition a été cancellée',
      propositionCancelledError: 'Une erreur est survenue lors de la cancellation de la proposition',
      propositionSaved: 'La proposition a été enregistrée',
      propositionDeclined: 'La proposition a été refusée pour le client',
      propositionDeclinedError: 'Une erreur est survenue lors du refus de la proposition',
      propositionAccepted: 'La proposition a été acceptée pour le client',
      propositionAcceptedError: 'Une erreur est survenue lors de l\'acceptation de la proposition',
      propositionModified: 'La proposition a été modifiée',
      propositionModifiedError: 'Une erreur est survenue lors de la modification de la proposition',
      averageDemography: 'Démographie moyenne',
      state: 'État',

      sortedBy: 'Ordonné par',
      name: 'Nom',
      propositionDate: 'Date de proposition',
      broadcastDate: 'Date de diffusion',

      summaryTotalWeeks: 'Total',

      notifications: {
        estimating: {
          title: 'En cours d\'estimation',
          message: 'Estimation en cours de calcul, ceci peut prendre un certain temps.',
        },
        success: {
          title: 'Estimation calculée',
          message: 'Votre estimation a été calculée. Cliquez ici pour la visionner.',
        },
        error: {
          title: 'Erreur du calcul d\'estimation',
          message: 'Il y a eu une erreur dans le calcul d\'estimation, veuillez nous contacter si ce problème persiste.',
        },
      },

      sentEstimation: {
        title: 'Le calcul de l\'estimation de vente a été ajouté à la file d\'attente',
        message: `
          Vous serez notifié lorsque le calcul sera terminé et se retrouvera dans « Historique ».
          Vous pouvez naviguer et démarrer d'autres estimations pendant ce temps.
        `,
      },

      progress: {
        queued: 'en attente',
        started: 'récupération des données',
        row: 'estimation d\'opportunité ({{current}}/{{total}})',
        summary: 'estimation du sommaire',
        success: 'estimation calculée',
        error: 'erreur dans l\'estimation',
      },

      lastNDays: 'hier',
      lastNDays_plural: '{{count}} derniers jours',

      lastNFullWeeks: 'Dernière semaine complète',
      lastNFullWeeks_plural: '{{count}} dernières semaines complètes',

      listeningHours: 'Écoute',
      listeningHoursPerPerson: 'Écoute par personne',
      couldNotLoadSalesProposals: 'Une erreur est survenue lors du chargement des propositions',
      smallMarketMessage: `La méthodologie de StatsRadio Spécialisée permet à des stations, se trouvant dans des marchés niches,
                          d’avoir accès à des données pertinentes sur une base mensuelle.
                          Les échantillons numériques relatifs à la démographie sont le résultat d’une agrégation de données de référence.`,
      propositionNotAvailableForCentralMarket: 'Les propositions ne sont pas disponible pour les marchés centraux',
    },
  },
  en: {
    sales: {
      accept: 'Accept',
      actions: 'Actions',
      addOpportunities: 'Add spots',
      averageFrequency: 'Average Frequency',
      calcul: 'Estimation',
      cancel: 'Cancel',
      chooseDateForTheCampaign: 'Choose weeks for the campaign',
      client: 'Client',
      cost: 'Cost',
      createProposition: 'Create a proposal',
      campaignDates: 'Campaign dates',
      decline: 'Decline',
      diffusion: 'Broadcast',
      estimationDate: 'Estimation date',
      estimationError: 'An error occured while calculating the estimation',
      flyerInformationMessage: 'Weekly performance from {{from, LL}} to {{to, LL}}',
      flyerPageTitle: 'Flyer',
      flyerCalculationText: '* Please note that the data for the last full week are calculated in the night of monday to tuesday',
      history: 'History',
      averageWeeklyHoursOfListening: 'Average Weekly Listening Time',
      averageWeeklyReach: 'Average Weekly Reach',
      averageWeeklyHoursOfListeningPerPerson: 'Average Weekly Listening Time per Person',
      impressions: 'Impressions',
      modify: 'Modify',
      modifyProposition: 'Modify a proposal',
      nbOfOccasions: 'Number of occasions',
      noEstimation: 'No recent estimation',
      noProposition: 'No proposals',
      notCalculated: 'The estimation was not calculated',
      noTitle: 'No title',
      propose: 'Propose',
      proposedOn: 'Proposed on',
      propositions: 'Proposals',
      estimationsPageTitle: 'Estimations',
      saveProposition: 'Save',
      saveAndSend: 'Save and send',
      send: 'Send',
      title: 'Title',
      requiredTitle: 'The title is required',
      requiredCustomer: 'The customer is required',
      totalReach: 'Total reach',
      bestWeeklyReach: 'Best Weekly Reach',
      bestWeeklyTotalListening: 'Best Weekly Listening Time',
      bestWeeklyTotalListeningPerPerson: 'Best Weekly Listening Time per Person',
      estimation: 'Estimation',
      description: 'Description',
      comments: 'Comments',
      sendProposition: 'Send proposal',
      fetchCustomersError: 'An error occured when acquiring the customers',
      selectCustomer: 'Select a customer',
      from: 'From',
      to: 'To',
      sendPropositionError: 'An error occured when sending the proposal',
      propositionSent: 'The proposal has been sent',
      acceptForCustomer: 'Accept for customer',
      declineForCustomer: 'Decline for customer',
      propositionCancelled: 'The proposal has been canceled',
      propositionCancelledError: 'An error occured when cancelling the proposal',
      propositionSaved: 'The proposal has been saved',
      propositionDeclined: 'The proposal has been declined for the customer',
      propositionDeclinedError: 'An error occured when declining the proposal',
      propositionAccepted: 'The proposal has been accepted for the customer',
      propositionAcceptedError: 'An error occured when accepting the proposal',
      propositionModified: 'The proposal has been modified',
      propositionModifiedError: 'An error occured when modifying the proposal',
      averageDemography: 'Average Demography',
      state: 'State',

      sortedBy: 'Sorted by',
      name: 'Name',
      propositionDate: 'Proposal Date',
      broadcastDate: 'Broadcast Date',

      summaryTotalWeeks: 'Total',

      notifications: {
        estimating: {
          title: 'Estimating',
          message: 'Currently calculating your estimation. This can take a while.',
        },
        success: {
          title: 'Estimation calculated',
          message: 'Your estimation was calculated. Click here to see it.',
        },
        error: {
          title: 'Error while calculating estimate',
          message: 'There was a problem while calculating the estimation. If it persists please contact us.',
        },
      },

      sentEstimation: {
        title: 'The estimation calculation was added to the queue',
        message: `
          You will be notified when the estimation is calculated. It will also be found in "History".
          You can navigate or calculate other estimations in the meantime.
        `,
      },

      progress: {
        queued: 'waiting',
        started: 'fetching relevant data',
        row: 'estimating opportunities ({{current}}/{{total}})',
        summary: 'estimating summary',
        success: 'estimation calculated',
        error: 'estimation error',
      },

      lastNDays: 'yesterday',
      lastNDays_plural: 'last {{count}} days',

      lastNFullWeeks: 'Last Full Week',
      lastNFullWeeks_plural: '{{count}} Last Full Weeks',

      listeningHours: 'Listening time',
      listeningHoursPerPerson: 'Listening time per person',
      couldNotLoadSalesProposals: 'Could not load sales proposals',
      smallMarketMessage: `Specialized StatsRadio Methodology provides radio stations in smaller niche markets with monthly audience data.
                          Digital samples relating to demographics are the result of an aggregation of reference data.`,
      propositionNotAvailableForCentralMarket: 'Propositions are not available for central market',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/i18n/sales.js